<template>
  <div class="accueil">
    <!-- Btn Retour -->
    <v-btn @click="$router.go(-1)" class="btnRetour"> </v-btn>

    <!-- Btn Accueil -->
    <v-btn
      @click="
        $router.push({
          name: 'Accueil',
        })
      "
      class="btnAccueil"
    >
    </v-btn>

    <!-- <a :href="publicPath + 'visites/lama/index.html'">
      <v-btn class="firstVisit"> </v-btn>
    </a> -->

    <!-- <div class="logoNosSentiers"></div> -->
    <span class="texteSentiers">{{ $t("logoTexte") }}</span>

    <div class="map"></div>

    <a :href="publicPath + 'visites/stelucietallano/index.html'">
    <!-- <a href="http://tests-sdp.arobase.corsica/stelucietallano/"> -->
      <v-btn class="tallano"></v-btn>
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Map",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      publicPath: "publicPathState",
    }),
  },
  methods: {},
};
</script>

<style scoped>
.accueil {
  background-image: url("../assets/maquette/fonds/background2.png");
  background-size: cover;
  height: 2242px;
  width: 1920px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.btnRetour {
  background-image: url("../assets/maquette/buttons/backButton.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: fixed;
  top: 15px;
  left: 14px;
  width: 117px;
  height: 117px !important;
  z-index: 1;
}

.btnAccueil {
  background-image: url("../assets/maquette/buttons/homeButton.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: fixed;
  top: 15px;
  left: 144px;
  width: 118px;
  height: 118px !important;
  z-index: 1;
}

.texteSentiers {
  font-size: 80px;
  color: white;
  position: absolute;
  top: 6px;
  left: 483px;
  font-family: "CenturyGothic";
}

.map {
  background-image: url("../assets/maquette/fonds/map.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: absolute;
  bottom: 0;
  width: 1684px;
  height: 2090px !important;
}

.tallano {
  background-image: url("../assets/maquette/buttons/map/tallano.png");
  background-size: cover;
  background-color: transparent !important;
  box-shadow: none;
  position: absolute;
  bottom: 472px;
  left: 790px;
  width: 160px;
  height: 121px !important;
}

.text-nowrap {
  -webkit-line-clamp: unset !important;
}
</style>
